ModalSysUserController.$inject = ['contact']

export default function ModalSysUserController(contact) {
  var vm = this

  vm.contact = contact
}